var _g, _rect, _rect2, _rect3, _g2, _g3, _rect4, _rect5, _rect6, _g4, _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPermissionsLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 376,
    height: 106,
    viewBox: "0 0 376 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10974_16813)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 13,
    width: 350,
    height: 30,
    rx: 2.5,
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26.75,
    y: 24.459,
    width: 17.1318,
    height: 7.5,
    rx: 3.75,
    fill: "#EBEBEF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 47.8353,
    y: 24.459,
    width: 207.5,
    height: 7.5,
    rx: 3.75,
    fill: "#EBEBEF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 259.289,
    y: 24.459,
    width: 60,
    height: 7.5,
    rx: 3.75,
    fill: "#EBEBEF"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10974_16813)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.583 20.5H345.917C346.138 20.5 346.35 20.5878 346.506 20.7441C346.662 20.9004 346.75 21.1123 346.75 21.3333V34.6667C346.75 34.8877 346.662 35.0996 346.506 35.2559C346.35 35.4122 346.138 35.5 345.917 35.5H332.583C332.362 35.5 332.15 35.4122 331.994 35.2559C331.838 35.0996 331.75 34.8877 331.75 34.6667V21.3333C331.75 21.1123 331.838 20.9004 331.994 20.7441C332.15 20.5878 332.362 20.5 332.583 20.5V20.5ZM338.419 31.3333L344.311 25.4408L343.133 24.2625L338.419 28.9767L336.062 26.6192L334.883 27.7975L338.419 31.3333Z",
    fill: "#121B2E"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_10974_16813)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 58,
    width: 350,
    height: 30,
    rx: 2.5,
    fill: "white"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 26.75,
    y: 69.459,
    width: 88.75,
    height: 7.5,
    rx: 3.75,
    fill: "#EBEBEF"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 119.453,
    y: 69.459,
    width: 40,
    height: 7.5,
    rx: 3.75,
    fill: "#EBEBEF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 163.407,
    y: 69.459,
    width: 156.25,
    height: 7.5,
    rx: 3.75,
    fill: "#EBEBEF"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_10974_16813)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M332.583 65.5H345.917C346.138 65.5 346.35 65.5878 346.506 65.7441C346.662 65.9004 346.75 66.1123 346.75 66.3333V79.6667C346.75 79.8877 346.662 80.0996 346.506 80.2559C346.35 80.4122 346.138 80.5 345.917 80.5H332.583C332.362 80.5 332.15 80.4122 331.994 80.2559C331.838 80.0996 331.75 79.8877 331.75 79.6667V66.3333C331.75 66.1123 331.838 65.9004 331.994 65.7441C332.15 65.5878 332.362 65.5 332.583 65.5V65.5ZM338.419 76.3333L344.311 70.4408L343.133 69.2625L338.419 73.9767L336.062 71.6192L334.883 72.7975L338.419 76.3333Z",
    fill: "#121B2E"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 12.5,
    fill: "#121B2E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9464 7.79989V18.709H12.9702V9.72283H12.9063L10.3548 11.3528V9.54173L13.0661 7.79989H14.9464Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10974_16813",
    x: 0.5,
    y: 5.5,
    width: 375,
    height: 55,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.105882 0 0 0 0 0.180392 0 0 0 0.11 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10974_16813"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10974_16813",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_10974_16813",
    x: 0.5,
    y: 50.5,
    width: 375,
    height: 55,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0705882 0 0 0 0 0.105882 0 0 0 0 0.180392 0 0 0 0.11 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10974_16813"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10974_16813",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10974_16813"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(329.25 18)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_10974_16813"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(329.25 63)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermissionsLoading);
export default __webpack_public_path__ + "static/media/permissions_loading.28f0418ee5ad66bf924df59e83b0206a.svg";
export { ForwardRef as ReactComponent };